<template>
  <div >
    <transition name="modal-fade">
      <div class="modal-mask" v-show="show">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Modal title</h5>
                <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" @click="show = false">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <slot></slot>

              </div>

            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: ['show'],
    name: "Modal",
    watch: {
      show(value) {
        // do nothing
      }
    }
  }
</script>

<style scoped>

  .btn-close {
    position: absolute;
    top: 30px;
    right: 30px;
    border-radius: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
  }

  .btn-close:hover {
    background-color: red;
    color: white;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
    display: table;
    transition: opacity .5s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-fade,
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/base/Modal.vue